/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ timecode: NonNullable<unknown> }} Audio_Embed_Export_Progress_RunningInputs */

const en_audio_embed_export_progress_running = /** @type {(inputs: Audio_Embed_Export_Progress_RunningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Embedding audio... ${i?.timecode}`)
};

const fr_audio_embed_export_progress_running = /** @type {(inputs: Audio_Embed_Export_Progress_RunningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Intégration audio... ${i?.timecode}`)
};

const de_audio_embed_export_progress_running = /** @type {(inputs: Audio_Embed_Export_Progress_RunningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Audio wird eingebettet... ${i?.timecode}`)
};

const it_audio_embed_export_progress_running = /** @type {(inputs: Audio_Embed_Export_Progress_RunningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Incorporamento audio... ${i?.timecode}`)
};

const ru_audio_embed_export_progress_running = /** @type {(inputs: Audio_Embed_Export_Progress_RunningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Встраивание аудио... ${i?.timecode}`)
};

const es_audio_embed_export_progress_running = /** @type {(inputs: Audio_Embed_Export_Progress_RunningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Insertando audio... ${i?.timecode}`)
};

const zh_cn2_audio_embed_export_progress_running = /** @type {(inputs: Audio_Embed_Export_Progress_RunningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`嵌入音频... ${i?.timecode}`)
};

const ja_audio_embed_export_progress_running = /** @type {(inputs: Audio_Embed_Export_Progress_RunningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`音声を埋め込んでいます... ${i?.timecode}`)
};

const hi_audio_embed_export_progress_running = /** @type {(inputs: Audio_Embed_Export_Progress_RunningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ऑडियो एम्बेड किया जा रहा है... ${i?.timecode}`)
};

const pt_pt2_audio_embed_export_progress_running = /** @type {(inputs: Audio_Embed_Export_Progress_RunningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Incorporando áudio... ${i?.timecode}`)
};

/**
* | output |
* | --- |
* | "Embedding audio... {timecode}" |
*
* @param {Audio_Embed_Export_Progress_RunningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_progress_running = /** @type {((inputs: Audio_Embed_Export_Progress_RunningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Progress_RunningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_progress_running(inputs)
	if (locale === "de") return de_audio_embed_export_progress_running(inputs)
	if (locale === "it") return it_audio_embed_export_progress_running(inputs)
	if (locale === "ru") return ru_audio_embed_export_progress_running(inputs)
	if (locale === "es") return es_audio_embed_export_progress_running(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_progress_running(inputs)
	if (locale === "ja") return ja_audio_embed_export_progress_running(inputs)
	if (locale === "hi") return hi_audio_embed_export_progress_running(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_progress_running(inputs)
	return en_audio_embed_export_progress_running(inputs)
});